<template>
  <span :class="getCssClass()">
    <GlobalEvents @click="cancelLookup()"></GlobalEvents>
    <input type="text" v-model="internal" @keyup.stop="lookupContact" :name="name.length > 0 ? name : false" :id="id.length > 0 ? id : false" :class="classes.length > 0 ? classes : false" />
    <ul class="autocomplete-selection" v-if="results.length > 0">
      <li class="autocomplete-item" v-for="res in results" :key="res.id" @click.stop="setContact(res.contactid)">{{ contactLookupLabel(res)}}</li>
    </ul>
  </span>
</template>

<script>
  import api from '@/api';
  import GlobalEvents from 'vue-global-events';

  export default {
    name: 'AutoCompleteContact',
    components: { GlobalEvents },
    props: {
      value: {
        type: String,
        required: false,
        default: () => ""
      },
      inline: {
        type: Boolean,
        required: false,
        default: () => false
      },
      name: {
        type: String,
        required: false,
        default: () => ""
      },
      id: {
        type: String,
        required: false,
        default: () => ""
      },
      classes: {
        type: String,
        required: false,
        default: () => ""
      },
    },
    data() {
      return {
        delay: null,
        results: [],
        working: false,
        internal: this.value
      }
    },
    methods: {
      getCssClass() {
        let css = ['autocomplete-wrapper'];
        if (this.working) {
          css.push('working');
        }
        if (this.inline) {
          css.push('inline');
        }
        return css.join(' ');
      },
      lookupContact(event) {
        if (event.keyCode === 27) {
          this.cancelLookup();
          return;
        }

        this.propagate();
        this.cancelLookup();

        if (this.internal.length <= 2) {
          return
        }
        
        this.working = true;

        this.delay = setTimeout(() => {
          let req = {
            contact: this.internal
          };
          api.lookupContact(
            req,
            data => {
              this.results = data.results;
              this.working = false;
              this.delay = null;
            },
            err => {
              this.results = [];
              this.working = false;
              this.delay = null;
            }
          )
        }, 500);

      },
      cancelLookup() {
        if (this.delay !== null) {
          clearTimeout(this.delay);
        }
        this.delay = null;
        this.results = [];
        this.working = false;
      },
      setContact(cid) {
        this.internal = cid;
        this.cancelLookup();
        this.propagate();
      },
      contactLookupLabel(c) {
        let out = [c.contactid];

        if (c.name.length > 0) {
          out.push(c.name);
        }

        if (c.org.length > 0) {
          out.push(c.org);
        }

        return out.join(', ');
      },
      propagate() {
        this.$emit('input', this.internal)
      }
    },
    watch: {
      // this is needed to "clear" internal value when prop changes.
      // the data is called only once so no change will take place on its own
      value(to, from) {
        this.internal = to;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AutoCompleteContact.vue